import { backofficeDialogOptions } from 'src/app/layout/shared/dialogs/backoffice-dialog.options';
import { productDialogOptions } from '../dialog-pilot/product-dialog.options';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { filter, finalize, Subscription, switchMap } from 'rxjs';
import { SiteAccessService } from 'src/app/core/services/team/site-access.service';
import { GenericConstants } from 'src/app/core/enums/generic-constants.enum';
import {
  ResourceRS,
  ResourcesRS,
} from 'src/app/core/models/resources/resources-response';
import { ResourcesService } from 'src/app/core/services/api/resources.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicImageCropperModalComponent } from '../dynamic-image-cropper-modal/dynamic-image-cropper-modal.component';
import { ImageConstraints } from 'src/app/core/models/store-templates/image-constraints';
import { OverlayService } from 'src/app/core/services/template/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import {
  MediaPickerModalComponent,
  MediaPickerResult,
} from '../media-picker-modal/media-picker-modal.component';


@Component({
  selector: 'app-dynamic-drop-zone',
  templateUrl: './dynamic-drop-zone.component.html',
  styleUrls: ['./dynamic-drop-zone.component.scss'],
})
export class DynamicDropZoneComponent implements OnInit {
  @Input() filesUrl?: Array<ResourcesRS> = [];
  @Input() siteId: string;
  @Input() single?: boolean = false;
  @Input() singleFile?: any;
  @Input() isInvalid?: boolean = false;
  @Input() imageConstraints?: ImageConstraints;
  @Input() isAiMode?: boolean = false; // Special AI mode with simplified dropzone design
  @Input() isExternalLoading?: boolean = false; // External trigger for loading spinner
  @Input() allowReorder: boolean = false;
  @Input() productDialogPilot = false;
  @Input() maxFiles?: number;
  aiSelectionBusy = false;

  onPilotFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);
    input.value = '';
    if (files.length) this.onSelect({ addedFiles: files });
  }

  private canAddFiles(count: number): boolean {
    if (!this.maxFiles || this.single || (this.filesUrl?.length || 0) + count <= this.maxFiles) return true;
    this.validationErrorMessage = this.translate.instant('bd_ai_max_photos', { count: this.maxFiles });
    this.validationError.emit(this.validationErrorMessage);
    return false;
  }

  /**
   * Al hacer CLIC en el area de subida, en vez de abrir directamente el explorador del equipo,
   * se pregunta de donde sacar la imagen: del equipo o de la biblioteca de la tienda.
   *
   * Activo por defecto. El arrastrar-y-soltar NO se ve afectado: sigue subiendo directo.
   * Se puede poner a false para recuperar el comportamiento antiguo en un hueco concreto.
   */
  @Input() allowLibraryPick: boolean = true;

  // ---- Límites opcionales, para quien tenga restricciones duras ----
  // Los tres son OPCIONALES y sin ellos el componente se comporta EXACTAMENTE como siempre. Se
  // añadieron para el logo del ticket del POS, que va a una impresora térmica y no admite lo que
  // admite una ficha de producto. Cualquier consumidor que no los pase no nota nada.

  /** Peso máximo en bytes. Sin él, no se mira el tamaño (comportamiento histórico). */
  @Input() maxSizeBytes?: number;

  /**
   * Ancho máximo en píxeles. Sin él, solo se aplica el ancho "recomendado" de `imageConstraints`,
   * que es un aviso y no bloquea. Esto SÍ bloquea: un fichero que no cabe no debería llegar a subirse.
   */
  @Input() maxWidthPx?: number;

  /**
   * Lista blanca de tipos MIME. Sin ella se usa la lista interna de siempre (imagen, audio, vídeo,
   * PDF). Sirve para restringir a, por ejemplo, solo PNG y JPEG.
   */
  @Input() acceptedMimeTypes?: string[];
    

  @Output() multimediaModelChange = new EventEmitter<any[]>();
  @Output() validationError = new EventEmitter<string>();
  // Notify parent when any upload is in progress so it can disable save actions
  @Output() uploadInProgressChange = new EventEmitter<boolean>();
  @Output() aiEnhanceEvent = new EventEmitter<{index: number, url: string}>();

  private uploadSubscriptions = new Map<File, Subscription>();

  /**
   * Id del último recurso subido en modo un fichero, para poder borrarlo al reemplazarlo.
   *
   * Solo cubre los subidos en ESTA sesión: un fichero que ya venía guardado llega como URL suelta,
   * sin id, y sin id el backend no sabe qué borrar. Es la misma limitación que tenía la subida
   * propia del ticket del POS antes de unificarla aquí.
   */
  private previousSingleResourceId: string | null = null;


  // Validation properties
  validationErrorMessage: string = '';
  validationWarningMessage: string = "";

  /** Evita que un doble clic sobre el area apile dos modales de seleccion. */
  private pickerOpen = false;
  isSingleFileUploading: boolean = false;
  isDragOver: boolean = false; // For AI mode drag over visual feedback
  activeUploads = 0;
  allowedExtensions: string[] = [
    // Images
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg',
    // Audio
    'mp3', 'wav', 'ogg', 'aac', 'm4a', 'flac',
    // Video
    'mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv',
    // Documents
    'pdf'
  ];
  allowedMimeTypes: string[] = [
    // Images
    'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml',
    // Audio
    'audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/aac', 'audio/mp4', 'audio/flac',
    // Video
    'video/mp4', 'video/avi', 'video/quicktime', 'video/x-ms-wmv', 'video/x-flv', 'video/webm', 'video/x-matroska',
    // Documents
    'application/pdf'
  ];

  //files: any[] = [];
  resourceItam: ResourcesRS = {};

  croppedImageBase64: Blob | null = null;

  //isCropping: boolean = false;
  imageChangedEvent: any = null;

  constructor(
    private resourseService: ResourcesService,
    private toastr: ToastrService, private modalService: NgbModal, private overlayService: OverlayService,
    // Solo para los mensajes de los límites nuevos. Los mensajes que ya había siguen en duro (y en
    // francés) a propósito: traducirlos es otra tarea y no toca hacerla de rebote aquí.
    private translate: TranslateService,
    private siteAccess: SiteAccessService
  ) {}

  ngOnInit() {
  }

  /**
   * Valide le type et la taille du fichier
   * @param file Fichier à valider
   * @returns objet avec isValid boolean et message d'erreur
   */
  validateFile(file: File): { isValid: boolean; error?: string } {
    if (this.isAiMode && !file.type.startsWith('image/')) return { isValid: false, error: this.translate.instant('ml_picker_type_rejected') };
    // Lista blanca del consumidor si la ha puesto; si no, la de siempre. Sin `acceptedMimeTypes`
    // esto es literalmente lo que había antes.
    const mimeTypes = this.acceptedMimeTypes?.length ? this.acceptedMimeTypes : this.allowedMimeTypes;
    if (!mimeTypes.includes(file.type)) {
      return {
        isValid: false,
        error: this.acceptedMimeTypes?.length
          ? this.translate.instant('dz_format_not_allowed', { formats: this.acceptedMimeTypes.join(', ') })
          : `Le fichier "${file.name}" n'est pas un format valide. Formats autorisés: Images, Audio, Vidéo, Pdf`
      };
    }

    // Vérifier l'extension du fichier (validation supplémentaire)
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (!fileExtension || !this.allowedExtensions.includes(fileExtension)) {
      return {
        isValid: false,
        error: `L'extension du fichier "${file.name}" n'est pas autorisée. Extensions autorisées: ${this.allowedExtensions.join(', ')}`
      };
    }

    // Peso: solo si el consumidor ha puesto un límite. Bloquea, no avisa — subir un fichero que se
    // sabe que no vale gasta red y deja un recurso inútil en el servidor.
    if (this.maxSizeBytes && file.size > this.maxSizeBytes) {
      return {
        isValid: false,
        error: this.translate.instant('dz_file_too_heavy', {
          max: Math.round(this.maxSizeBytes / 1024),
          actual: Math.round(file.size / 1024)
        })
      };
    }

    return { isValid: true };
  }

  /**
   * Suelta el recurso anterior de modo un fichero y anota el nuevo.
   *
   * Best-effort a propósito: si el borrado falla, el usuario ya tiene su imagen nueva y no le
   * importa que haya quedado un fichero suelto en el servidor. Nunca debe hacer fallar la subida.
   */
  private releasePreviousSingleResource(newResourceId?: string): void {
    const previous = this.previousSingleResourceId;
    this.previousSingleResourceId = newResourceId || null;
    if (previous && previous !== newResourceId) {
      // Solo quien puede borrar medios: a los demás el 403 les saltaría el aviso de acceso aunque la
      // subida haya ido bien (y el fichero suelto no les importa).
      this.siteAccess.can(this.siteId, 'design.media.delete').pipe(
        filter(Boolean), switchMap(() => this.resourseService.deleteResource(this.siteId, previous)),
      ).subscribe({
        next: () => undefined,
        error: () => undefined
      });
    }
  }

  /**
   * Efface les erreurs de validation
   */
  clearValidationError() {
    this.validationErrorMessage = '';
    this.validationWarningMessage = '';
  }

  // ---- Upload activity tracking ----
  private beginUpload() {
    this.activeUploads++;
    if (this.activeUploads === 1) {
      this.uploadInProgressChange.emit(true);
    }
  }
  private finishUpload() {
    if (this.activeUploads > 0) this.activeUploads--;
    // Clear single file uploading state
    if (this.single) {
      this.isSingleFileUploading = false;
      this.overlayService.hide();
    }
    if (this.activeUploads === 0) {
      // Finished all uploads: notify parent it's now safe to save
      this.uploadInProgressChange.emit(this.aiSelectionBusy);
      this.emitIfIdle();
    }
  }
  private emitIfIdle() {
    if (this.activeUploads === 0) {
      this.multimediaModelChange.emit(this.filesUrl);
    }
  }

  onReorder(newList: any[]) {
    this.filesUrl = newList;
    this.multimediaModelChange.emit(this.filesUrl);
  }
  async onSelect(event) {
    // Effacer les erreurs de validation précédentes
    console.log('on select files in drop zone');
    console.log(event)
    this.clearValidationError();
    if (!event.addedFiles?.length || !this.canAddFiles(event.addedFiles.length)) return;
    const trackedSelection = this.productDialogPilot && this.isAiMode;
    if (trackedSelection && this.aiSelectionBusy) return;
    if (trackedSelection) { this.aiSelectionBusy = true; this.uploadInProgressChange.emit(true); }
    try {
    if (this.single) {
      const validation = this.validateFile(event.addedFiles[0]);
      if (!validation.isValid) {
        this.validationErrorMessage = validation.error!;
        return;
      }
      let fileSubType = event.addedFiles[0].type.split('/');
      switch (fileSubType[0]) {
        case 'image': {
          if (this.imageConstraints && this.imageConstraints.aspect_ratio) {
            this.fileToCropper(event.addedFiles[0]);
            break;
          }
          else{
            const { meta, error, warning } = await this.prepareImage(event.addedFiles[0]);
            if (error) {
              this.validationErrorMessage = error;
              this.validationError.emit(error);
              return;
            }
            if (warning) this.validationWarningMessage = warning;
            this.uploadResource(ResourceRS.TypeEnum.PHOTO, event.addedFiles[0], undefined, meta);
            break;
          }
        }
        case 'audio': {
          this.uploadResource(ResourceRS.TypeEnum.AUDIO, event.addedFiles[0]);
          break;
        }
        case 'video': {
          this.uploadResource(ResourceRS.TypeEnum.VIDEO, event.addedFiles[0]);
          break;
        }
        case 'application': {
          if (fileSubType[1] == 'pdf' || 
              fileSubType[1].includes('document') || 
              fileSubType[1].includes('word')) {
            this.uploadResource(ResourceRS.TypeEnum.PDF, event.addedFiles[0]);
          }
          break;
        }
        case 'text': {
          this.uploadResource(ResourceRS.TypeEnum.PDF, event.addedFiles[0]);
          break;
        }
      }
    } else {
      // Valider tous les fichiers avant traitement
      for (let i = 0; i < event.addedFiles.length; i++) {
        const validation = this.validateFile(event.addedFiles[i]);
        if (!validation.isValid) {
          this.validationErrorMessage = validation.error!;
          this.validationError.emit(validation.error!);
          return; // Arrêter le traitement si un fichier est invalide
        }
      }

      for (let index = 0; index < event.addedFiles.length; index++) {
        this.resourceItam = {};
        let fileSubType = event.addedFiles[index].type.split('/');
        switch (fileSubType[0]) {
          case 'image': {
            const { meta, error, warning } = await this.prepareImage(event.addedFiles[index]);
            if (error) {
              this.validationErrorMessage = error;
              this.validationError.emit(error);
              // Ignorer cette image et continuer avec les autres
              break;
            }
            if (warning) this.validationWarningMessage = warning;
            this.resourceItam.file = event.addedFiles[index];
            this.resourceItam.type = ResourceRS.TypeEnum.PHOTO;
            this.resourceItam.loading = true;
            this.filesUrl.push(this.resourceItam);
            this.uploadResource(
              ResourceRS.TypeEnum.PHOTO,
              event.addedFiles[index],
              undefined,
              meta
            );
            console.log('image metadata (multi):', meta);
            break;
          }
          case 'audio': {
            this.resourceItam.file = event.addedFiles[index];
            this.resourceItam.type = ResourceRS.TypeEnum.AUDIO;
            this.resourceItam.loading = true;
            this.filesUrl.push(this.resourceItam);
            this.uploadResource(
              ResourceRS.TypeEnum.AUDIO,
              event.addedFiles[index]
            );
            break;
          }
          case 'video': {
            this.resourceItam.file = event.addedFiles[index];
            this.resourceItam.type = ResourceRS.TypeEnum.VIDEO;
            this.resourceItam.loading = true;
            this.filesUrl.push(this.resourceItam);
            this.uploadResource(
              ResourceRS.TypeEnum.VIDEO,
              event.addedFiles[index]
            );
            break;
          }
          case 'application': {
            if (fileSubType[1] == 'pdf') {
              this.resourceItam.file = event.addedFiles[index];
              this.resourceItam.type = ResourceRS.TypeEnum.PDF;
              this.resourceItam.loading = true;
              this.filesUrl.push(this.resourceItam);
              this.uploadResource(
                ResourceRS.TypeEnum.PDF,
                event.addedFiles[index]
              );
            }
            break;
          }
        }
      }
      this.emitIfIdle();//this.multimediaModelChange.emit();
    }

    console.log('files resources');
    console.log(this.filesUrl);
    } finally {
      if (trackedSelection) {
        this.aiSelectionBusy = false;
        this.uploadInProgressChange.emit(this.activeUploads > 0);
      }
    }
  }

  fileToCropper(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Guarda la URL para alimentar el cropper
      this.imageChangedEvent = { target: { files: [file] }, dataUrl: reader.result };
      const cropperEvent = { target: { files: [file] }, dataUrl: reader.result };
      const imgMeta =  this.getImageMetadata(file);
      console.log("before get image meta data");
      console.log(imgMeta);
      this.openCropperModal(cropperEvent)
    };
   
  }

 

  openCropperModal(cropperEvent: any) {
    const modalRef = this.modalService.open(DynamicImageCropperModalComponent, backofficeDialogOptions('product-crop', 'wide'));
    
    // Pasa el evento de la imagen al modal como input
    modalRef.componentInstance.productDialogPilot = this.productDialogPilot;
    modalRef.componentInstance.imageChangedEvent = cropperEvent;
    modalRef.componentInstance.imageConfig = this.imageConstraints;

    // 3. Suscribirse al resultado cuando se cierra el modal
    modalRef.result.then((result) => {
      // El resultado es el Base64 de la imagen recortada
      if (result) {
        console.log("on cropper modal accept ");
        console.log(result);
         
        if ( result instanceof File) {
        console.log("result is instance of file");
        console.log(result);
        const imgMeta =  this.getImageMetadata(result);
        console.log("after get image meta data");
        console.log(imgMeta);
        this.uploadResource(ResourceRS.TypeEnum.PHOTO, result, undefined);
        
      }
      }
    }, (reason) => {
      // Se canceló el modal
      //this.files = [];
      console.log('Recorte Cancelado:', reason);
    });
  }

  uploadResource(fileType: string, fileToUpload?: File, url?: string, imgMeta?: { width: number; height: number; aspectRatio: string }) {
     this.beginUpload();
    if (this.single) {
      this.isSingleFileUploading = true;
      this.overlayService.show();
    }

    let fileData: FormData = new FormData();
    fileData.set('siteId', this.siteId);
    fileData.set('type', fileType);
    fileData.append('target', GenericConstants.TARGET_ITEM);
    fileData.append('url', url);
    fileData.append('file', fileToUpload);
    // Inclure les métadonnées de l'image si disponibles (largeur/hauteur/ratio)
   /* if (imgMeta && fileType === ResourceRS.TypeEnum.PHOTO) {
      // Clés préférées
      fileData.append('image_width', String(imgMeta.width));
      fileData.append('image_height', String(imgMeta.height));
      fileData.append('image_aspect_ratio', imgMeta.aspectRatio);
      // Clés génériques pour compatibilité backend
      fileData.append('width', String(imgMeta.width));
      fileData.append('height', String(imgMeta.height));
      fileData.append('aspect_ratio', imgMeta.aspectRatio);
    }*/

   const uploadSub = this.resourseService
      .uploadResourceSync(this.siteId, fileData)
      .pipe(finalize(() => {
        if (fileToUpload) this.uploadSubscriptions.delete(fileToUpload);
        this.finishUpload();
      }))
      .subscribe(

      (res) => {
        // Effacer les erreurs de validation précédentes en cas de succès
        this.clearValidationError();
        
        let index = this.filesUrl.findIndex((x) => x.file === fileToUpload);
        if (index === -1 && !this.single) {
          console.warn('Upload finished but file was already removed from UI');
          return;
        }

        this.resourceItam = JSON.parse(JSON.stringify(res));
        console.log('on update resources');
        console.log(this.resourceItam);
        if (!this.single) {
          this.filesUrl[index].id = this.resourceItam.id;
          this.filesUrl[index].url = this.resourceItam.url;
          this.filesUrl[index].loading = false;
          this.filesUrl.slice();
          //this.multimediaModelChange.emit();
        } else {
          // Antes de pisar la URL: soltar el recurso que había, o cada reemplazo deja basura en el
          // servidor. Solo se puede con los subidos en esta sesión — un fichero que venía guardado
          // llega como URL sin id, y sin id no hay nada que borrar (ver `previousSingleResourceId`).
          this.releasePreviousSingleResource(this.resourceItam.id);
          this.singleFile.value = this.resourceItam.url;
          //this.multimediaModelChange.emit();

        }

        console.log(
          'product to edit after  upload new file  and set resource data'
        );
        console.log(this.filesUrl);
      },
      (error) => {
        console.log('error uploading resources ');
        console.log(error);

        // Guard against removed file
        let index = this.filesUrl.findIndex((x) => x.file === fileToUpload);
        if (index === -1 && !this.single) return;
        
        // Extraire le message d'erreur depuis error.detail si disponible, sinon utiliser error.message ou error.error.message
        let errorMessage = '';
        if (error.error?.detail) {
          errorMessage = error.error.detail;
        } else if (error.detail) {
          errorMessage = error.detail;
        } else if (error.error?.message) {
          errorMessage = error.error.message.split(';')[0];
        } else if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = 'Erreur lors du téléchargement du fichier';
        }
        
        if (!this.single) {
          if (index !== -1) {
            this.toastr.error(
              errorMessage + ' FOR FILE = ' + this.filesUrl[index].file.name,
              'Error Uploading File'
            );
            this.filesUrl.splice(index, 1);
          } else {
            this.toastr.error(errorMessage, 'Error Uploading File');
          }
          // Définir le message d'erreur de validation à afficher sous la zone de dépôt
          this.validationErrorMessage = errorMessage;
        } else {
          // Gérer l'erreur de téléchargement de fichier unique - définir l'erreur de validation à afficher sous la zone de dépôt
          this.validationErrorMessage = errorMessage;
        }
        //this.multimediaModelChange.emit();
      }
    );

    if (fileToUpload) {
      this.uploadSubscriptions.set(fileToUpload, uploadSub);
    }
  }

  /**
   * Lit la largeur/hauteur réelle de l'image et calcule le ratio d'aspect depuis un File
   */
  private getImageMetadata(file: File): Promise<{ width: number; height: number; aspectRatio: string } | undefined> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));
        const d = gcd(width, height);
        const simplifiedW = Math.round(width / d);
        const simplifiedH = Math.round(height / d);
        resolve({ width, height, aspectRatio: `${simplifiedW}:${simplifiedH}` });
      };
      img.onerror = () => resolve(undefined);
      img.src = URL.createObjectURL(file);
    });
  }

  /**
   * Compare les ratios d'aspect avec tolérance en convertissant les deux en nombres
   */
  private isMatchingRatio(actual: string, required: string, tolerance: number = 0.02): boolean {
    // Accept if strings are exactly identical
    if (actual === required) return true;

    const [aw, ah] = actual.split(':').map(Number);
    const [rw, rh] = required.split(':').map(Number);
    if (!aw || !ah || !rw || !rh) return true;

    // Accept if unsimplified required equals actual simplified or unsimplified actual matches required
    const unsimplifiedActual = `${aw}:${ah}`; // already actual
    if (unsimplifiedActual === required) return true;

    // Compute simplified version of required ratio to compare with simplified actual
    const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));
    const d = gcd(rw, rh);
    const simplifiedRequired = `${Math.round(rw / d)}:${Math.round(rh / d)}`;
    if (simplifiedRequired === actual) return true;

    const a = aw / ah;
    const r = rw / rh;
    return Math.abs(a - r) <= tolerance;
  }

  /**
   * Prépare l'image en extrayant les métadonnées et en validant contre les contraintes requises.
   * Retourne meta pour l'upload et les messages d'avertissement/erreur quand applicable.
   */
  private async prepareImage(file: File): Promise<{ meta?: { width: number; height: number; aspectRatio: string }, warning?: string, error?: string }> {
    const imgMeta = await this.getImageMetadata(file);
    if (!imgMeta) {
      return { error: 'Unable to read image metadata.' };
    }
    const decimalRatio = `${(imgMeta.width / imgMeta.height).toFixed(0)}:1`;
    let warning: string | undefined;
    let error: string | undefined;

    // Ancho máximo duro, distinto del `width` "recomendado" de imageConstraints (que solo avisa).
    // Se comprueba ANTES que el resto para que el mensaje que ve el usuario sea el del límite que
    // de verdad impide subir la imagen, y no un aviso de proporción que no viene al caso.
    if (this.maxWidthPx && imgMeta.width > this.maxWidthPx) {
      return {
        meta: imgMeta,
        error: this.translate.instant('dz_image_too_wide', {
          max: this.maxWidthPx,
          actual: imgMeta.width
        })
      };
    }
    if (this.imageConstraints) {
      if (this.imageConstraints.required && this.imageConstraints.aspect_ratio) {
        //const exactMatch = imgMeta.width === this.imageSize.width && imgMeta.height === this.imageSize.height;
        let ratioOk = true;
        ratioOk = this.isMatchingRatio(imgMeta.aspectRatio, this.imageConstraints.aspect_ratio);
        if (!ratioOk) {
          //const simplifiedRequired = `${Math.round(rw / d)}:${Math.round(rh / d)}`;
          error = `This image must respect the required ratio ${this.imageConstraints.aspect_ratio} or recomended size ${this.imageConstraints.width}×${this.imageConstraints.height} . Uploaded one is: ${imgMeta.width}×${imgMeta.height} (${decimalRatio}).`;
        }
      } else {
        const differs = imgMeta.width !== this.imageConstraints.width || imgMeta.height !== this.imageConstraints.height;
        if (differs) {
          warning = `Recommended size ${this.imageConstraints.width}×${this.imageConstraints.height} pixels. Uploaded: ${imgMeta.width}×${imgMeta.height} pixels.`;
        }
      }
    }

    return { meta: imgMeta, warning, error };
  }

  onRemove(event) {
    // Effacer les erreurs de validation lors de la suppression de fichiers
    this.clearValidationError();
    
    // Check if the file is currently uploading and cancel it
    const file = this.filesUrl[event]?.file;
    if (file) {
      const sub = this.uploadSubscriptions.get(file);
      if (sub) {
        sub.unsubscribe();
        this.uploadSubscriptions.delete(file);
      }
    }

    // HOTFIX: no borramos el fichero del servidor, solo la referencia local.
    // El id se quita de la entidad igual que antes, pero el fichero se queda en S3.
    this.filesUrl.splice(event, 1);
    this.filesUrl.slice();
    this.emitIfIdle();

    // this.resourseService.deleteResource(this.siteId, this.filesUrl[event].id).subscribe(
    //   (res) => {
    //     this.filesUrl.splice(event, 1);
    //     this.filesUrl.slice();
    //     //this.multimediaModelChange.emit();
    //     this.emitIfIdle();
    //   },
    //   (error) => {
    //     console.log('error on removing files from server');
    //     console.log(error);
    //
    //     // Gérer l'erreur lors de la suppression de fichiers du serveur
    //     let errorMessage = '';
    //     if (error.error?.detail) {
    //       errorMessage = error.error.detail;
    //     } else if (error.detail) {
    //       errorMessage = error.detail;
    //     } else if (error.error?.message) {
    //       errorMessage = error.error.message;
    //     } else {
    //       errorMessage = 'Erreur lors de la suppression du fichier';
    //     }
    //
    //     this.validationErrorMessage = errorMessage;
    //     this.toastr.error(errorMessage, 'Error Removing File');
    //   }
    // );
    console.log(this.filesUrl);
  }

  /**
   * Annule le téléchargement de fichier pendant le chargement
   * @param index Index du fichier à annuler
   */
  onCancelUpload(index: number) {
    // Effacer les erreurs de validation lors de l'annulation du téléchargement
    this.clearValidationError();
    
    // Cancel the upload subscription if it exists
    const file = this.filesUrl[index]?.file;
    if (file) {
        const sub = this.uploadSubscriptions.get(file);
        if (sub) {
            sub.unsubscribe();
            this.uploadSubscriptions.delete(file);
        }
    }

    // Simplement supprimer le fichier du tableau pendant le chargement
    this.filesUrl.splice(index, 1);
    //this.multimediaModelChange.emit();
    this.emitIfIdle();
  }

  onRemoveSingle(event) {
    // Effacer les erreurs de validation lors de la suppression du fichier unique
    this.clearValidationError();

    // Se olvida el id anotado, pero NO se borra el recurso: quitar la imagen del formulario no es
    // lo mismo que confirmar el cambio, y el usuario todavía puede cancelar. Quien decide si eso
    // hay que limpiarlo es el padre, que es el que sabe si se guardó.
    this.previousSingleResourceId = null;

    // In single mode, we might not have the File object in the map if it was already uploaded
    // but we check anyway just in case of AI mode or recent upload
    if (this.uploadSubscriptions.size > 0) {
      this.uploadSubscriptions.forEach((sub, file) => {
        sub.unsubscribe();
      });
      this.uploadSubscriptions.clear();
    }

    //this.multimediaModelChange.emit();
    this.emitIfIdle();
  }

  /**
   * Opens the file URL in a new tab and stops propagation to prevent triggering the dropzone.
   */
  openFile(event: Event, url: string): void {
    // stopPropagation SIEMPRE, tambien cuando aun no hay url (subida en curso). Si no, un clic
    // sobre una miniatura a medio subir burbujea al contenedor y abre el modal de seleccion.
    event.stopPropagation();
    if (!url) return;
    // Un fichero muerto abriria una pestana con el 403/404 del CDN. El clic no hace nada;
    // el boton de borrar sigue disponible encima del placeholder.
    if (this.isBroken(url)) return;
    window.open(url, '_blank');
  }


  // ---------------------------------------------------------------------------
  // Seleccion desde la biblioteca de medios
  //
  // Estos metodos NO tocan onSelect, uploadResource, beginUpload/finishUpload ni
  // activeUploads. El camino "desde el equipo" reutiliza onSelect tal cual, para no
  // duplicar la validacion de ficheros.
  // ---------------------------------------------------------------------------

  /**
   * Abre el selector: de donde saco la imagen, del equipo o de la biblioteca de la tienda.
   */
  /**
   * Clic sobre el area de subida.
   *
   * Con allowLibraryPick activo, ngx-dropzone tiene el clic desactivado via [disableClick],
   * asi que en lugar de abrirse el explorador del equipo se pregunta de donde sacar la imagen.
   *
   * El arrastrar-y-soltar NO pasa por aqui: ngx-dropzone escucha el evento 'drop' por separado
   * y no lo afecta disableClick, o sea que soltar un fichero lo sube directo sin preguntar.
   *
   * Los clics de los botones internos de la preview (borrar, cancelar, abrir, mejorar con IA)
   * tampoco llegan: todos hacen stopPropagation en custom-dropzone-preview.
   */
  /**
   * Tipos de fichero admitidos por ESTA instancia.
   *
   * Unica fuente de verdad: la usan tanto el area de arrastrar-y-soltar como la pestana
   * "del equipo" del modal. Antes el modal tenia su propia lista fija y en modo IA se podia
   * colar un PDF por el modal aunque el area solo aceptase imagenes.
   */
  get acceptTypes(): string {
    return this.isAiMode
      ? 'image/*'
      : 'image/*,audio/*,video/*,.pdf,.doc,.docx,.txt,.rtf';
  }

  onZoneClick(event: Event): void {
    if (!this.allowLibraryPick) {
      // Comportamiento de siempre: ngx-dropzone abre el explorador del equipo.
      return;
    }

    // ngx-dropzone deja su input file en el DOM, oculto pero TABULABLE. Al activarlo con
    // teclado el navegador abre el dialogo nativo y ademas el click burbujea hasta aqui:
    // sin esta guarda se abririan los dos a la vez.
    const target = event.target as HTMLElement;
    if (target && target instanceof HTMLInputElement && target.type === "file") {
      return;
    }

    // Doble clic sobre el area: sin guarda se apilaban dos modales, cada uno con su propia
    // instancia de la biblioteca haciendo su peticion.
    if (this.pickerOpen) {
      return;
    }

    this.openLibraryPicker(event);
  }

  openLibraryPicker(event?: Event): void {
    if (!this.canAddFiles(1) || this.aiSelectionBusy) return;
    if (event) {
      // El contenedor lleva la directiva ngx-dropzone y abriria el selector nativo de ficheros.
      event.stopPropagation();
    }

    const modalRef = this.modalService.open(MediaPickerModalComponent, backofficeDialogOptions('product-media', 'wide'));
    modalRef.componentInstance.productDialogPilot = this.productDialogPilot;
    modalRef.componentInstance.siteId = this.siteId;
    modalRef.componentInstance.multiple = !this.single;
    // El accept debe ser el de ESTA instancia, no uno fijo: el modo IA solo admite imagenes
    // y sin esto se podia colar un PDF por la pestana "del equipo".
    modalRef.componentInstance.accept = this.acceptTypes;
    // El accept solo limita la pestana del equipo. En modo IA, que solo admite imagenes,
    // hay que restringir tambien la biblioteca o se podria elegir un PDF ya subido.
    modalRef.componentInstance.forcedType = this.isAiMode ? ResourceRS.TypeEnum.PHOTO : null;
    this.pickerOpen = true;

    modalRef.result.then(
      (result: MediaPickerResult) => {
        this.pickerOpen = false;
        if (!result) {
          return;
        }
        if (result.source === 'device' && result.files && result.files.length > 0) {
          // Mismo flujo de siempre: misma validacion, misma subida, mismos contadores.
          this.onSelect({ addedFiles: result.files });
          return;
        }
        if (result.source === 'library' && result.resource) {
          this.applyLibraryResource(result.resource);
        }
      },
      () => {
        // Modal cancelado, no hay nada que hacer.
        this.pickerOpen = false;
      }
    );
  }

  /**
   * Coloca un recurso ya existente SIN volver a subirlo: se reutiliza la misma URL de S3.
   *
   * Si el hueco exige un ratio concreto, la imagen pasa antes por el recorte, y eso si
   * genera un fichero nuevo; el original de la biblioteca no se modifica.
   */
  private applyLibraryResource(resource: ResourcesRS): void {
    // Misma condicion que usa onSelect para el camino "del equipo": basta con que el hueco
    // declare aspect_ratio. Antes se exigia ademas "required", y eso hacia que la misma
    // imagen se recortase al subirla y no al reutilizarla.
    const needsCrop =
      !!this.imageConstraints &&
      !!this.imageConstraints.aspect_ratio &&
      (resource.type === ResourceRS.TypeEnum.PHOTO || this.isImage(resource.url));

    if (needsCrop) {
      this.cropLibraryResource(resource);
      return;
    }

    this.placeLibraryResource(resource);
  }

  /**
   * Descarga la imagen y la entrega al cropper que ya existe. Al aceptar, fileToCropper
   * llama a uploadResource, o sea que el recorte sigue el flujo de subida normal.
   *
   * OJO, limitacion del CDN (verificado 2026-08-22): CloudFront NO devuelve
   * `access-control-allow-origin` en las respuestas 200 de los objetos, ni siquiera cuando
   * la peticion manda `Origin`. Un <img> se ve igual porque no necesita CORS, pero un fetch
   * queda bloqueado, asi que aqui no siempre se pueden leer los bytes.
   *
   * Cuando pasa NO se descarta la imagen: se coloca tal cual, sin recortar, y se avisa. Es
   * lo mismo que ya hace `openCropperWithUrl` en el editor de plantillas, y es mejor que un
   * callejon sin salida: el recurso viene de la biblioteca, o sea que ya se subio y se valido
   * una vez por este mismo componente.
   *
   * El arreglo de verdad esta en la distribucion de CloudFront: reenviar la cabecera `Origin`
   * al origen e invalidar la cache. Eso ademas desatasca el recorte de las imagenes de IA,
   * que hoy falla en silencio por lo mismo.
   */
  private cropLibraryResource(resource: ResourcesRS): void {
    fetch(resource.url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.blob();
      })
      .then((blob) => {
        const fileName = resource.original_filename || 'biblioteca.png';
        const file = new File([blob], fileName, { type: blob.type || 'image/png' });
        this.fileToCropper(file);
      })
      .catch((err) => {
        // Se registra el motivo real: tragarselo fue justo lo que hizo indiagnosticable
        // el fallo de la rejilla en la fase 6.
        console.error('DROPZONE- no se ha podido descargar la imagen de la biblioteca para recortarla', resource.url, err);
        this.validationWarningMessage = this.translate.instant('ml_picker_crop_failed');
        this.placeLibraryResource(resource);
      });
  }

  /**
   * Escribe el recurso en el modelo del padre, respetando los dos modos del dropzone.
   *
   * Se emite con emitIfIdle para no pisar una subida en curso: si la hay, sera
   * finishUpload quien emita al terminar, ya con este recurso incluido.
   */
  private placeLibraryResource(resource: ResourcesRS): void {
    if (!this.canAddFiles(1)) return;
    if (this.single) {
      this.singleFile.value = resource.url;
    } else {
      this.filesUrl.push({
        id: resource.id,
        url: resource.url,
        type: resource.type,
        loading: false,
      });
    }
    this.emitIfIdle();
  }

  /**
   * Helper to determine if a URL represents an image.
   */
  /**
   * URLs cuyo fichero ya no existe en el servidor. Se indexa por URL, no por indice: al subir
   * un fichero nuevo la URL cambia, con lo que no hay que resetear nada.
   */
  private readonly brokenUrls = new Set<string>();

  isBroken(url?: string): boolean {
    return !!url && this.brokenUrls.has(url);
  }

  /**
   * Angular retira el <img> del DOM en el siguiente ciclo de deteccion de cambios, asi que la
   * carga no se reintenta y no hay bucle.
   */
  onImageError(url?: string): void {
    if (url) {
      this.brokenUrls.add(url);
    }
  }

  isImage(url: string): boolean {
    if (!url) return false;
    const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExtensions.includes(extension || '');
  }

  /**
   * Helper to determine if a URL represents a PDF.
   */
  isPdf(url: string): boolean {
    if (!url) return false;
    const extension = url.split('?')[0].split('.').pop()?.toLowerCase();
    return extension === 'pdf';
  }
}
